export var cuppingDescriptorHierarchy = {
    name: '',
    bgColor: '',
    children: [
        {
            name: 'Fruity',
            bgColor: '#DA1D23',
            children: [
                {
                    name: 'Berry',
                    bgColor: '#DD4C51',
                    children: [
                        { name: 'Blackberry', bgColor: '#3E0317', value: 1 },
                        { name: 'Raspberry', bgColor: '#E52968', value: 1 },
                        { name: 'Blueberry', bgColor: '#6469B0', value: 1 },
                        { name: 'Strawberry', bgColor: '#EF2D36', value: 1 },
                    ],
                },
                {
                    name: 'Dried fruit',
                    bgColor: '#C94A44',
                    children: [
                        { name: 'Raisin', bgColor: '#B53B54', value: 1 },
                        { name: 'Prune', bgColor: '#A5446F', value: 1 },
                    ],
                },
                {
                    name: 'Other fruit',
                    bgColor: '#F2684C',
                    children: [
                        { name: 'Coconut', bgColor: '#D07C36', value: 1 },
                        { name: 'Cherry', bgColor: '#E73451', value: 1 },
                        { name: 'Pomegranate', bgColor: '#E65656', value: 1 },
                        { name: 'Pineapple', bgColor: '#F89A1C', value: 1 },
                        { name: 'Grape', bgColor: '#AEB92C', value: 1 },
                        { name: 'Apple', bgColor: '#4EB947', value: 1 },
                        { name: 'Peach', bgColor: '#F68A5C', value: 1 },
                        { name: 'Pear', bgColor: '#BAA635', value: 1 },
                    ],
                },
                {
                    name: 'Citrus fruit',
                    bgColor: '#F7A129',
                    children: [
                        { name: 'Grapefruit', bgColor: '#F26355', value: 1 },
                        { name: 'Orange', bgColor: '#E2631E', value: 1 },
                        { name: 'Lemon', bgColor: '#FDE402', value: 1 },
                        { name: 'Lime', bgColor: '#7EB138', value: 1 },
                    ],
                },
            ],
        },
        {
            name: 'Sour/Fermented',
            bgColor: '#EBB40D',
            children: [
                {
                    name: 'Sour',
                    bgColor: '#E1C315',
                    children: [
                        { name: 'Sour aromatics', bgColor: '#9EA718', value: 1 },
                        { name: 'Acetic acid', bgColor: '#94A770', value: 1 },
                        { name: 'Butyric acid', bgColor: '#D0B34F', value: 1 },
                        { name: 'Isovaleric acid', bgColor: '#8EB646', value: 1 },
                        { name: 'Citric acid', bgColor: '#FAEF08', value: 1 },
                        { name: 'Malic acid', bgColor: '#C1BA09', value: 1 },
                    ],
                },
                {
                    name: 'Alcohol/Fermented',
                    bgColor: '#C94A44',
                    children: [
                        { name: 'Winey', bgColor: '#8F1B53', value: 1 },
                        { name: 'Whiskey', bgColor: '#B34039', value: 1 },
                        { name: 'Fermented', bgColor: '#BA9232', value: 1 },
                        { name: 'Overripe', bgColor: '#8B6439', value: 1 },
                    ],
                },
            ],
        },
        {
            name: 'Green/Vegetative',
            bgColor: '#197A2F',
            children: [
                {
                    name: 'Olive oil',
                    bgColor: '#A2B028',
                    value: 1,
                },
                {
                    name: 'Raw',
                    bgColor: '#708933',
                    value: 1,
                },
                {
                    name: 'Green/Vegetative',
                    bgColor: '#3AA255',
                    children: [
                        { name: 'Under-ripe', bgColor: '#A2BC2B', value: 1 },
                        { name: 'Peapod', bgColor: '#62AA3C', value: 1 },
                        { name: 'Fresh', bgColor: '#03A653', value: 1 },
                        { name: 'Dark green', bgColor: '#048549', value: 1 },
                        { name: 'Vegetative', bgColor: '#27B44B', value: 1 },
                        { name: 'Hay-like', bgColor: '#A3A830', value: 1 },
                        { name: 'Herb-like', bgColor: '#7AC141', value: 1 },
                    ],
                },
                {
                    name: 'Beany',
                    bgColor: '#5E9A80',
                    value: 1,
                },
            ],
        },
        {
            name: 'Other',
            bgColor: '#0AA3B5',
            children: [
                {
                    name: 'Papery/Musty',
                    bgColor: '#9DB2B7',
                    children: [
                        { name: 'Stale', bgColor: '#8B8C90', value: 1 },
                        { name: 'Cardboard', bgColor: '#BDB175', value: 1 },
                        { name: 'Papery', bgColor: '#FEFEF4', value: 1 },
                        { name: 'Woody', bgColor: '#744F02', value: 1 },
                        { name: 'Moldy/Damp', bgColor: '#A3A36F', value: 1 },
                        { name: 'Musty/Dusty', bgColor: '#C9B583', value: 1 },
                        { name: 'Musty/Earthy', bgColor: '#988847', value: 1 },
                        { name: 'Animalic', bgColor: '#9D977F', value: 1 },
                        { name: 'Meaty/Brothy', bgColor: '#CC7B6A', value: 1 },
                        { name: 'Phenolic', bgColor: '#DB646A', value: 1 },
                    ],
                },
                {
                    name: 'Chemical',
                    bgColor: '#76C0CB',
                    children: [
                        { name: 'Bitter', bgColor: '#80A89D', value: 1 },
                        { name: 'Salty', bgColor: '#DEF2FD', value: 1 },
                        { name: 'Medicinal', bgColor: '#7A9BAE', value: 1 },
                        { name: 'Petroleum', bgColor: '#039FB8', value: 1 },
                        { name: 'Skunky', bgColor: '#5E777B', value: 1 },
                        { name: 'Rubber', bgColor: '#120C0C', value: 1 },
                    ],
                },
            ],
        },
        {
            name: 'Roasted',
            bgColor: '#C94930',
            children: [
                {
                    name: 'Pipe tobacco',
                    bgColor: '#CAA465',
                    value: 1,
                },
                {
                    name: 'Tobacco',
                    bgColor: '#DFBD7E',
                    value: 1,
                },
                {
                    name: 'Burnt',
                    bgColor: '#BE8663',
                    children: [
                        { name: 'Acrid', bgColor: '#B9A449', value: 1 },
                        { name: 'Ashy', bgColor: '#899893', value: 1 },
                        { name: 'Smoky', bgColor: '#A1743B', value: 1 },
                        { name: 'Brown, Roast', bgColor: '#894810', value: 1 },
                    ],
                },
                {
                    name: 'Cereal',
                    bgColor: '#DDAF61',
                    children: [
                        { name: 'Grain', bgColor: '#B7906F', value: 1 },
                        { name: 'Malt', bgColor: '#EB9D5E', value: 1 },
                    ],
                },
            ],
        },
        {
            name: 'Spices',
            bgColor: '#AD213E',
            children: [
                {
                    name: 'Pungent',
                    bgColor: '#794652',
                    value: 1,
                },
                {
                    name: 'Pepper',
                    bgColor: '#CC3C42',
                    value: 1,
                },
                {
                    name: 'Brown spice',
                    bgColor: '#B14D57',
                    children: [
                        { name: 'Anise', bgColor: '#C78935', value: 1 },
                        { name: 'Nutmeg', bgColor: '#8C292C', value: 1 },
                        { name: 'Cinnamon', bgColor: '#E5762E', value: 1 },
                        { name: 'Clove', bgColor: '#A16C5A', value: 1 },
                    ],
                },
            ],
        },
        {
            name: 'Nutty/Cocoa',
            bgColor: '#A87B64',
            children: [
                {
                    name: 'Nutty',
                    bgColor: '#C78869',
                    children: [
                        { name: 'Peanuts', bgColor: '#D4AD13', value: 1 },
                        { name: 'Hazelnut', bgColor: '#9D5433', value: 1 },
                        { name: 'Almond', bgColor: '#C89F83', value: 1 },
                    ],
                },
                {
                    name: 'Cocoa',
                    bgColor: '#BB764C',
                    children: [
                        { name: 'Chocolate', bgColor: '#692A19', value: 1 },
                        { name: 'Dark chocolate', bgColor: '#470603', value: 1 },
                    ],
                },
            ],
        },
        {
            name: 'Sweet',
            bgColor: '#E65832',
            children: [
                {
                    name: 'Brown sugar',
                    bgColor: '#D45A59',
                    children: [
                        { name: 'Molasses', bgColor: '#310C0F', value: 1 },
                        { name: 'Maple syrup', bgColor: '#AE341F', value: 1 },
                        { name: 'Caramelized', bgColor: '#D78823', value: 1 },
                        { name: 'Honey', bgColor: '#DA5C1F', value: 1 },
                    ],
                },
                {
                    name: 'Vanilla',
                    bgColor: '#F89A80',
                    value: 1,
                },
                {
                    name: 'Vanillin',
                    bgColor: '#F37674',
                    value: 1,
                },
                {
                    name: 'Overall sweet',
                    bgColor: '#E75B68',
                    value: 1,
                },
                {
                    name: 'Sweet Aromatics',
                    bgColor: '#D0545F',
                    value: 1,
                },
            ],
        },
        {
            name: 'Floral',
            bgColor: '#DA0D68',
            children: [
                {
                    name: 'Black Tea',
                    bgColor: '#975E6D',
                    value: 1,
                },
                {
                    name: 'Floral',
                    bgColor: '#E0719C',
                    children: [
                        { name: 'Chamomile', bgColor: '#F99E1B', value: 1 },
                        { name: 'Rose', bgColor: '#EF5A78', value: 1 },
                        { name: 'Jasmine', bgColor: '#F7F1BD', value: 1 },
                    ],
                },
            ],
        },
    ],
};
